import React from "react";

const App404Component = () => {
  console.log("You have reached the app 404 page.");

  return (
    <div className="app-inner-container-wrapper">
      <h4>App 404 Page | Page not found.</h4>
    </div>
  );
};

export default App404Component;
